import enUS from './locales/en-US'
import idID from './locales/id-ID'
import thTH from './locales/th-TH'
import viVN from './locales/vi-VN'
import antdEn from 'antd/lib/locale-provider/en_US'
import antdId from 'antd/lib/locale-provider/id_ID'
import antdTh from 'antd/lib/locale-provider/th_TH'
import antdVi from 'antd/lib/locale-provider/vi_VN'

const AppLocale = {
  en: {
    messages: {
      ...enUS
    },
    antd: antdEn,
    locale: 'en-US'
  },
  id: {
    messages: {
      ...idID
    },
    antd: antdId,
    locale: 'id-ID'
  },
  th: {
    messages: {
      ...thTH
    },
    antd: antdTh,
    locale: 'th-TH'
  },
  vi: {
    messages: {
      ...viVN
    },
    antd: antdVi,
    locale: 'vi-VN'
  }
}

export default AppLocale
